<p-inputNumber
  class="sales-portal-input"
  [(ngModel)]="value"
  mode="decimal"
  (ngModelChange)="onChange($event)"
  [min]="min"
  [maxFractionDigits]="maxFractionDigits"
  [minFractionDigits]="minFractionDigits"
  [disabled]="disabled"
  [style.height]="height"
  [allowEmpty]="false"
></p-inputNumber>
